<button type="button" (click)="toggle()" class="btn w-100 d-block">
  <div class="line">
    <div class="text-block" [ngClass]="{'open': visible}" >
      {{visible ? textOpen : textClosed}}
    </div>
  </div>
</button>
@if (visible) {
  <ng-content></ng-content>
}
